import { GroupsBackroomState } from '../../types/backroomSection';
import { setSelectedFolder } from '../actions/backroomSection';

const defaultState = {
  folder: undefined,
  search: undefined,
} as GroupsBackroomState;

export default function backroomSectionReducer(
  state = defaultState,
  action
): GroupsBackroomState {
  const { type, payload } = action;
  switch (type) {
    case setSelectedFolder.toString():
      return {
        ...state,
        folder: payload.folder,
      };
    default:
      return state;
  }
}
